var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"account-name"},[(
      _vm._column.modelResource.account && _vm._column.modelResource.account !== null
    )?_c('div',[_c('div',{staticClass:"sub-info"},[_c('span',[_vm._v(" "+_vm._s(_vm.handleAccount(_vm._column.modelResource.account))+" ")])])]):_vm._e(),(!_vm._column.modelResource.account)?_c('div',[(
        _vm.$session?.marks.any('SYS:ALL_MODULE') &&
        (_vm.$session.type === 'account' ||
          _vm.$session.permissions.is('SHOW_ALL_MENUS')) && _vm.show
      )?_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.editShop}},[_c('i',{staticClass:"el-icon-circle-plus c1fc969"}),_vm._v(" "+_vm._s(_vm.$t("main.open_bind_account_username"))+" ")]):_vm._e(),(!_vm.show)?_c('span',[_vm._v("-")]):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }